import React, {useEffect, useState} from 'react';

import {H2, H4, Body3, Label2, Label3} from '@bootcamp/web/src/components/Typography/next';
import {Link} from 'react-router-dom';
import {Add} from '@styled-icons/fluentui-system-filled/Add';
import {Subtract} from '@styled-icons/fluentui-system-filled/Subtract';
import {ChevronRight} from '@styled-icons/fluentui-system-filled/ChevronRight';

import ProgressBar from '@bootcamp/web/src/components/ProgressBar';

import styled, {css} from 'styled-components';

// dat icons
import bio from '@bootcamp/shared/src/assets/icons/dat/biology.png';
import gc from '@bootcamp/shared/src/assets/icons/dat/general-chemistry.png';
import oc from '@bootcamp/shared/src/assets/icons/dat/organic-chemistry.png';
import pa from '@bootcamp/shared/src/assets/icons/dat/perceptual-ability.png';
import rc from '@bootcamp/shared/src/assets/icons/dat/reading-comprehension.png';
import qr from '@bootcamp/shared/src/assets/icons/dat/quantitative-reasoning.png';

// msb icons
import heart from '@bootcamp/shared/src/assets/icons/msb/heart.png';
import hair from '@bootcamp/shared/src/assets/icons/msb/hair.png';
import embryo from '@bootcamp/shared/src/assets/icons/msb/embryo.png';
import intestine from '@bootcamp/shared/src/assets/icons/msb/intestine.png';
import anatomy from '@bootcamp/shared/src/assets/icons/msb/anatomy.png';
import blood from '@bootcamp/shared/src/assets/icons/msb/blood.png';
import histo from '@bootcamp/shared/src/assets/icons/msb/histo.png';
import virus from '@bootcamp/shared/src/assets/icons/msb/virus.png';
import nephro from '@bootcamp/shared/src/assets/icons/msb/nephro.png';
import brain from '@bootcamp/shared/src/assets/icons/msb/brain.png';
import psych from '@bootcamp/shared/src/assets/icons/msb/psych.png';
import lung from '@bootcamp/shared/src/assets/icons/msb/lung.png';
import biostatistics from '@bootcamp/shared/src/assets/icons/msb/biostatistics.png';
import endo from '@bootcamp/shared/src/assets/icons/msb/endo.png';
import genetics from '@bootcamp/shared/src/assets/icons/msb/genetics.png';
import womb from '@bootcamp/shared/src/assets/icons/womb.png';
import musculoskeletal from '@bootcamp/shared/src/assets/icons/musculoskeletal.png';
import pubhealthsci from '@bootcamp/shared/src/assets/icons/pubhealthsci.png';
import biochem from '@bootcamp/shared/src/assets/icons/chemistry/oc.png';
import microbio from '@bootcamp/shared/src/assets/icons/msb/microbio.png';
import patho from '@bootcamp/shared/src/assets/icons/chemistry/gc.png';
import pharm from '@bootcamp/shared/src/assets/icons/msb/pharm.png';

// nclex icons
import adultHealth from '@bootcamp/shared/src/assets/icons/nclex/AdultHealth.png';
import childHealth from '@bootcamp/shared/src/assets/icons/nclex/ChildHealth.png';
import criticalCare from '@bootcamp/shared/src/assets/icons/nclex/CriticalCare.png';
import fundamentals from '@bootcamp/shared/src/assets/icons/nclex/Fundamentals.png';
import maternalNewbornHealth from '@bootcamp/shared/src/assets/icons/nclex/MaternalandNewbornHealth.png';
import mentalHealth from '@bootcamp/shared/src/assets/icons/nclex/MentalHealth.png';
import pharmacology from '@bootcamp/shared/src/assets/icons/nclex/Pharmacology.png';
import managementOfCare from '@bootcamp/shared/src/assets/icons/nclex/ManagementofCare.png';

// inbde icons
import medicine from '@bootcamp/shared/src/assets/icons/inbde/medicine.png';
import fieldsOfDentistry from '@bootcamp/shared/src/assets/icons/inbde/fields_of_dentistry.png';
import anatomyPhysiology from '@bootcamp/shared/src/assets/icons/inbde/anatomy_physiology.png';
import research from '@bootcamp/shared/src/assets/icons/inbde/research.png';
import oralPath from '@bootcamp/shared/src/assets/icons/inbde/oral_pathology.png';
import patientManagement from '@bootcamp/shared/src/assets/icons/inbde/patient_management.png';
import pharma from '@bootcamp/shared/src/assets/icons/inbde/pharmacology.png';
import simExam from '@bootcamp/shared/src/assets/icons/inbde/simulation_exam.png';
import firstAid from '@bootcamp/shared/src/assets/icons/nclex/FirstAid.png';

export const iconMap = {
  'med-school': {
    'Cardiology': heart,
    'Dermatology': hair,
    'Embryology': embryo,
    'Gastroenterology': intestine,
    'Gross Anatomy': anatomy,
    'Hematology & Oncology': blood,
    'Histology': histo,
    'Immunology': virus,
    'Nephrology': nephro,
    'Neuroanatomy': brain,
    'Neurology': brain,
    'Psychiatry': psych,
    'Pulmonology': lung,
    'Biostatistics': biostatistics,
    'Endocrinology': endo,
    'Genetics': genetics,
    'Reproduction': womb,
    'Musculoskeletal': musculoskeletal,
    'Public Health Sciences': pubhealthsci,
    'Pharmacology (Principles)': pharm,
    'Biochemistry': biochem,
    'Microbiology': microbio,
    'Pathology': patho,
  },
  'dat': {
    'Biology': bio,
    'General Chemistry': gc,
    'Organic Chemistry': oc,
    'Perceptual Ability': pa,
    'Reading Comprehension': rc,
    'Quantitative Reasoning': qr,
  },
  'nclex': {
    'Adult Health': adultHealth,
    'Child Health': childHealth,
    'Critical Care': criticalCare,
    'Fundamentals': fundamentals,
    'Maternal & Newborn Health': maternalNewbornHealth,
    'Mental Health': mentalHealth,
    'Pharmacology': pharmacology,
    'Management of Care': managementOfCare,
  },
  'inbde': {
    'Fields of Dentistry': fieldsOfDentistry,
    'Oral Pathology and Oral Radiology': oralPath,
    'Medicine': medicine,
    'Pharmacology': pharma,
    'Clinical Management': patientManagement,
    'Anatomy and Physiology': anatomyPhysiology,
    'Research': research,
    'Case Sets': firstAid,
    'Simulation Exam': simExam,
  }
};

export const Card = styled.div`
  background: ${({theme}) => theme.colors.neutralsPalette.white};
  box-shadow: ${({theme}) => theme.elevation.shadow.medium};
  border-radius: 8px;
  margin-bottom: 48px;
  overflow: hidden;
`;
export const Row = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
`;
export const Column = styled.div`
  display: flex;
  flex-direction: column;
`;
export const Label = styled(H4)`
  margin-bottom: ${({theme}) => theme.layouts.spacing.m};
`;
export const Title = styled(H2)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: white;
  `;
export const TitleWithFilter = styled(Title)`
  flex-flow: row wrap;
  justify-content: space-between;
  gap: 8px;

  span {
    white-space: nowrap;
    margin-right: ${({theme}) => theme.layouts.spacing.m};
  }

  ${({theme}) => theme.mediaQueries.mobileXl} {
    flex-direction: column;
    align-items: flex-start;
  }
`;
export const SubTitle = styled(Body3)`
  margin-top: 4px;
  color: ${({theme}) => theme.colors.typographyPalette.transparent};
`;
export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: ${({theme}) => theme.colors.neutralsPalette.light};
  margin: ${({theme}) => `${theme.layouts.spacing.l} 0`};
`;
export const Heading = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${({theme}) => theme.layouts.spacing.m};

  h3 {
    margin-bottom: 0;
  }
`;

const BlurbContainer = styled.div`
  position: relative;
  padding-left: ${({icon}) => icon ? '32px' : '0px'}
`;
export const BlurbText = styled(Body3)`
  background: ${({theme, lightMode}) => lightMode || theme.darkModeEnabled ? theme.overlays.opacity.light._100 : theme.colors.brandPalette.royal.light};
  color: ${({theme, lightMode}) => lightMode ? 'white' : theme.colors.typographyPalette.primary};
  border-radius: 8px;
  padding: ${({theme, icon}) => `${theme.layouts.spacing.ml} ${theme.layouts.spacing.l}`};

  ${({theme}) => theme.mediaQueries.tablet} {
    padding: ${({theme}) => `${theme.layouts.spacing.ms} ${theme.layouts.spacing.l}`};
  }
`;
export const BlurbIcon = styled.img`
  position: absolute;
  width: 42px;
  height: 42px;
  border-radius: 21px;
  border: 3px solid ${({theme}) => theme.overlays.opacity.light._100};
  top: calc(50% - 21px);
  left: 0;
`;

const ExpandContainer = styled(Body3)`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: white;
`;
const ExpandIcon = styled.svg`
  width: 16px;
  height: 16px;
  margin-right: 4px;
`;

export const Expand = ({expanded, setExpanded}) => {
  return (
    <ExpandContainer onClick={() => setExpanded(!expanded)}>
      {expanded ? <ExpandIcon as={Subtract} /> : <ExpandIcon as={Add} />} {expanded ? 'Collapse All' : 'Expand All'}
    </ExpandContainer>
  );
}

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  border-radius: 8px;
  overflow: hidden;
  font-family: 'proxima-nova';
  color: ${({theme}) => theme.colors.neutralsPalette.extraDark};
  table-layout: ${({fixed}) => fixed ? 'fixed' : 'auto'};

  tr {
    border-bottom: 1px solid ${({theme}) => theme.colors.neutralsPalette.light};
  }
  tr:last-child {
    border-bottom: none;
  }

  tr:first-child {
    background: ${({theme}) => theme.colors.neutralsPalette.offWhite};
    border-bottom: 1px solid ${({theme}) => theme.colors.neutralsPalette.light};

    td {
      font-weight: 600;
      color: ${({theme}) => theme.colors.neutralsPalette.grey};
    }
  }
`;
export const Icon = styled.div`
  width: 16px;
  color: ${({theme}) => theme.colors.neutralsPalette.lightGrey};
  cursor: pointer;
`;
const Chevron = styled(Icon)`
  width: 20px;
`;
export const TableRow = styled.tr`
  cursor: ${({parent, onClick}) => !!onClick || parent ? 'pointer' : 'auto'};
  box-shadow: ${({nested, isExpanded, theme}) => nested || isExpanded ? `3px 0px inset rgb(237, 237, 240);` : `none` };
  background: ${({theme, isExpanded, background, nested}) => nested ? theme.colors.backgroundPalette.secondary : '#FFF'};

  &:hover {
    background: ${({onClick, theme, parent, noHover}) => noHover ? 'auto' : !!onClick || parent ? theme.colors.elevationPalette.surfaceSecondary : 'none'};

    ${Icon} {
      color: ${({theme}) => theme.colors.brandPalette.royal.default};
    }
  }
`;
export const Cell = styled.td`
  color: ${({theme, disabled}) => disabled && theme.colors.typographyPalette.secondary};
  padding: ${({width, theme}) => `${theme.layouts.spacing.m} ${theme.layouts.spacing.m}`};
  text-align: ${({width}) => width ? `center` : 'left'};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 100%;

  ${({background}) => background && `background: ${background};`};
  ${({color}) => color && `* {color: ${color} !important;}`};

  &:first-child {
    width: 48px;
    padding-left: ${({theme}) => theme.layouts.spacing.l};
  }

  &:last-child {
    text-align: right;
    width: ${({hasContent}) => hasContent ? 'auto' : '48px'};
  }
`;

export const SubjectCell = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;
export const CellText = styled(Label2)`
  color: ${({theme}) => theme.colors.typographyPalette.primary};
  white-space: nowrap;
`;
export const MasteryCountCellText = styled(CellText)`
  width: 78px;
`;
export const BarCell = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
export const BarCellText = styled(Label2)`
  color: ${({theme}) => theme.colors.typographyPalette.primary};
  width: 42px;
`;
export const CellSecondary = styled(Label2)`
  width: 78px;
  color: ${({theme}) => theme.colors.typographyPalette.secondary};
`;
export const CellIcon = styled.img`
  width: 20px;
  height: 20px;
`;
export const TopicCell = styled.div`
  margin-left: 28px;
`;

const StyledProgressBar = styled(ProgressBar)`
  width: ${({width}) => width ? width : '100px'} !important;
`;

export const CellProgressBar = ({segments, total, loading=false, markPosition, width}) => {
  return (
    <StyledProgressBar
      segments={segments}
      total={total}
      width={width}
      // label={
      //   <BarBottomLabel>
      //     {loading ? 'loading...' :label}
      //   </BarBottomLabel>
      // }
      lightMode
      bareLabel
      withMargin={false}
      loading={loading}
      markPosition={markPosition}
      // targetNumber={targets?.averageScorePercentage}
      // targetLabel={!stillCollecting && `${targets?.averageScorePercentage}%`}
      // targetMet={!stillCollecting && scoreTargetMet}
    />
  );
}

export const Blurb = ({className, icon, bareIcon, text, lightMode, children}) => (
  <BlurbContainer className={className} icon={icon}>
    {icon && <BlurbIcon src={icon} />}
    <BlurbText lightMode={lightMode} icon={icon}>
      {bareIcon && bareIcon}
      {text}
      {children}
    </BlurbText>
  </BlurbContainer>
);

export const TableOverflowOuterWrapper = styled.div`
  ${({parentHasPadding}) => parentHasPadding && css`
    position: absolute;
    right: -32px;
    left: -32px;
  `}

  ${({theme}) => theme.mediaQueries.tablet} {
    overflow-x: initial;

    ${({parentHasPadding}) => parentHasPadding && css`
      position: absolute;
      padding: 0 16px;
    `}
  }
`;

export const TableOverflowInnerWrapper = styled.div`
  padding: 0 32px 16px;
  overflow-x: auto;

  ${({theme}) => theme.mediaQueries.tablet} {
    padding: 0 16px 16px;
    width: auto;
    margin-bottom: 0;
    margin-right: 0;
    margin-left: 0;
  }
`;
const CellContent = styled.span`
  color: ${({theme, disabled}) => disabled ? theme.colors.typographyPalette.secondary : theme.colors.typographyPalette.primary};
  text-decoration: ${({as}) => as === 'span' ? 'none' : 'underline'};

  ${({theme}) => theme.mediaQueries.laptopL} {
    word-wrap: ${({breakWord}) => breakWord ? 'break-word' : 'normal'};

  }
  ${({theme}) => theme.mediaQueries.tablet} {
    word-wrap: normal;
  }
`;
const ParentButtonPlaceholder = styled.div`
  width: 32px;
  height: 32px;
`;
export const Table = ({rows, className, expandAll, hideChevrons=false, buttonElement, fixed=true, hideLastCell, loading}) => {
  const [expandedRows, setExpandedRows] = useState({});

  function handleRowExpansion(index) {
    if (loading) return;

    const isExpanded = expandedRows[index];

    setExpandedRows({...expandedRows, [index]: !isExpanded});
  }

  function renderRow(row, index) {
    if (row.hasOwnProperty('cells')) {
      return (
        <TableRow key={`table-row-${index}`} onClick={row.onClick}>
          {row?.cells?.map(({content, background, color, to, disabled, elementProps={}}, cellIndex) => {
            const contentLength = typeof content === 'string' ? content.length : 0;
            const spaces = typeof content === 'string' ? content?.split(' ').length - 1 : 0;
            const breakWord = contentLength > 20 && spaces === 0;

            return (
              <Cell key={`table-cell-${cellIndex}`} hasContent={!!content} background={background} color={color} {...elementProps}>
                <CellContent as={to ? Link : 'span'} breakWord={breakWord} to={to} disabled={disabled} target="_blank">{content}</CellContent>
              </Cell>
            );
          })}
        </TableRow>
      );
    } else {
      // here we're assuming a row is passed as an object with nested rows
      const {parent, nested} = row;
      const isExpanded = expandedRows[index];
      const ButtonComponent = buttonElement;

      return (
        <>
          <TableRow key={`table-row-${index}`} isExpanded={isExpanded} onClick={() => handleRowExpansion(index)} parent>
            <Cell key={`table-cell-parent-toggle`}>
              {isExpanded ? <Icon as={Subtract}/> : <Icon as={Add}/>}
            </Cell>
            {parent?.map(({content, disabled}, cellIndex) => (
              <Cell key={`table-cell-${cellIndex}`} onClick={() => cellIndex === 0 && handleRowExpansion(index)} disabled={disabled}>{content}</Cell>
            ))}
            {!hideLastCell &&
              <Cell key={`table-cell-parent-placeholder`}>
                {buttonElement && <ParentButtonPlaceholder/>}
              </Cell>}
          </TableRow>

          {isExpanded &&
            nested?.map(({cells, onClick, background, noHover}) => (
                <TableRow key={`table-row-nested-${index}`} onClick={buttonElement ? null : onClick} nested background={background} noHover={noHover}>
                  {cells?.map(({ content, disabled }, index) => (
                    <Cell key={`table-cell-nested-${index}`} disabled={disabled}>{content}</Cell>
                  ))}
                  {!hideLastCell &&
                    <Cell key={`table-cell-parent-toggle`}>
                      {!hideChevrons && !buttonElement && <Chevron as={ChevronRight} />}
                      {!hideChevrons && buttonElement && <ButtonComponent onClick={onClick} disabled={!onClick} />}
                    </Cell>
                    }
                </TableRow>
            ))
          }
        </>
      );
    }

  }

  useEffect(() => {
    if (expandAll === null) return;

    if (expandAll) {
      setExpandedRows(rows.reduce((acc, curr, index) => ({...acc, [index]: true}), {}));
    } else {
      setExpandedRows({});
    }
  }, [expandAll, rows]);

  return (
    <StyledTable className={className} fixed={fixed}>
      {rows?.map(renderRow)}
    </StyledTable>
  );
}

const DivergentBarContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  height: ${({height}) => height}px;
  overflow: hidden;
`;
const Bar = styled.div`
  width: ${({percentage}) => percentage}%;
  height: 100%;
  background: ${({theme, color}) => theme.colors.interfacePalette[color].gradient};
`;
const Left = styled.div`
  padding: 4px 0px;
  display: flex;
  justify-content: flex-end;
  flex: 1;
  height: 100%;

`;
const Right = styled.div`
  padding: 4px 0px;
  flex: 1;
  height: 100%;
`;
const BarDivider = styled.div`
  background: ${({theme}) => theme.colors.borderPalette.secondary};
  width: ${({width}) => width}px;
  height: 100%;
`;

export const DivergentBar = ({reference, value, height=28, dividerWidth=3}) => {
  const disparity = Math.abs(reference - value);
  const percentage = Math.round((disparity / reference) * 100);

  return (
    <DivergentBarContainer height={height}>
      <Left>
        {reference > value && <Bar color={'green'} percentage={percentage}/>}
      </Left>
      <BarDivider width={dividerWidth}/>
      <Right>
        {reference < value && <Bar color={'red'} percentage={percentage}/>}
      </Right>
    </DivergentBarContainer>
  );
};

export const LineLabelContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: 0 auto;
`;
export const LineLabelWrapper = styled(Label3)`
  position: absolute;
  color: ${({theme}) => theme.colors.typographyPalette.secondary};
  white-space: nowrap;
`;